import * as ActionTypes from "./ActionTypes.js";
import { axiosapi } from "../api/axiosapi.js";
export const addBus = (buses) => ({
  type: ActionTypes.ADD_BUSES,
  payload: buses,
});
export const fetchBookingByRoute = (booking) => ({
  type: ActionTypes.FETCH_BOOKING_BYROUTE,
  payload: booking,
});

export const addNewBooking = (bus_id, routeId, seats) => (dispatch) => {
  const newBookingData = {
    bus_id: bus_id,
    routeId: routeId,
    seats: [],
    boardingPoint: null,
    droppingPoint: null,
  };
  newBookingData.seats.push(seats);


  dispatch(addNewBookingFunc(newBookingData));
};
const addNewBookingFunc = (newBooking) => ({
  type: ActionTypes.ADD_NEW_BOOKING,
  payload: newBooking,
});
export const removeSeats = (seats) => ({
  type: ActionTypes.REMOVE_SEATS,
  payload: seats,
});
export const addSeatToArray = (seat) => ({
  type: ActionTypes.ADD_NEW_SEAT_TO_ARRAY,
  payload: seat
})

export const addBoardingPoint = (boardingPoint) => ({
  type: ActionTypes.ADD_BOARDING_POINT,
  payload: boardingPoint,
});
export const addDroppingPoint = (droppingPoint) => ({
  type: ActionTypes.ADD_DROPPING_POINT,
  payload: droppingPoint,
});
export const addJourneyDetails =
  (originCity, destinationCity, dateofJourney) => (dispatch) => {
    const newJourneyDetails = {
      originCity: originCity,
      destinationCity: destinationCity,
      dateofJourney: dateofJourney,
    };
    dispatch(journeyDetailsFunc(newJourneyDetails));
  };
export const journeyDetailsFunc = (journeyDetails) => ({
  type: ActionTypes.ADD_JOURNEY_DETAILS_BOOKING,
  payload: journeyDetails,
});

export const addUserDetailsToState = (userinfo) => ({
  type: ActionTypes.USER_LOGGED_IN,
  payload: userinfo
})
export const clearBookingState = () => ({
  type: ActionTypes.CLEAR_BOOKING_STATE
})
export const logout = () => async (dispatch) => {
  console.log("hii")
  const response = await axiosapi.get("/auth/logout", { headers: { 'Content-type': 'application/json' }, withCredentials: true })
  console.log(response)
  dispatch(logoutFunction())
}
const logoutFunction = () => ({
  type: ActionTypes.USER_LOGGED_OUT,
})
export const addContactDetails = (email, mobile) => ({
  type: ActionTypes.ADD_EMAIL_MOBILE,
  payload: { email, mobile }
})
export const updateSeatWithPerson = (seat) => ({
  type: ActionTypes.UPDATE_SEAT_WITH_PERSON_DETAILS,
  payload: seat
})
